import { api, getAuthHeader } from "../axiosConfig";
import { notifyService } from "./notifyService";

// Hide a user from the Settings list and block their login. Admin-only.
export async function archiveUser(email) {
  return await api
    .put("/admin/archiveUser", { email }, { headers: getAuthHeader() })
    .then((res) => {
      notifyService("User archived");
      return true;
    })
    .catch((err) => {
      notifyService(err?.response?.data || "Failed to archive user");
      return false;
    });
}

// Bring an archived user back. Admin-only.
export async function restoreUser(email) {
  return await api
    .put("/admin/restoreUser", { email }, { headers: getAuthHeader() })
    .then((res) => {
      notifyService("User restored");
      return true;
    })
    .catch((err) => {
      notifyService(err?.response?.data || "Failed to restore user");
      return false;
    });
}
